import { all } from 'redux-saga/effects';
// import authSagas from './auth/saga';
import statusSaga from './status/saga';
import statusSagaV2 from './v2/status/saga';

export default function* rootSaga() {
  yield all([
    // authSagas(),
    statusSaga(),
    statusSagaV2(),
  ]);
}
